import React, { useState } from 'react';
import '../../Styles/PartnerReg.css'; // Import the CSS file

const HeroSection = ({ bgImage, toggleModal }) => {
  const [isContactPopupVisible, setIsContactPopupVisible] = useState(false);

  const toggleContactPopup = () => {
    setIsContactPopupVisible(!isContactPopupVisible);
  };

  return (
    <div
      className="hero-section"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <h1 className="hero-title">Partner with Book ur Spot</h1>
      <p className="hero-subtitle">
        0% commission for the first month for new partners in selected cities
      </p>
      <button className="register-btn" onClick={toggleModal}>
        Register your venue
      </button>
      <button className="contact-sales-btn" onClick={toggleContactPopup}>
        Contact Sales
      </button>

      {/* Contact Popup */}
      {isContactPopupVisible && (
        <div className="contact-popup">
          <h3 className="popup-title">Sales Contact Information</h3>
          <p className="popup-text">
            <strong>Phone:</strong> +1-234-567-890
          </p>
          <p className="popup-text">
            <strong>Email:</strong> sales@bookurspot.com
          </p>
          <button className="popup-close-btn" onClick={toggleContactPopup}>
            Close
          </button>
        </div>
      )}

      {/* Overlay */}
      {isContactPopupVisible && (
        <div className="popup-overlay" onClick={toggleContactPopup}></div>
      )}
    </div>
  );
};

export default HeroSection;
